import React, { useState, useEffect } from 'react';
import AccessibleModal from './AccessibleModal';
import { ITEM_TAGS } from '../data/itemsCatalog';

const ItemEditModal = ({ 
  isOpen, 
  onClose, 
  item, 
  onSave, 
  isCustom = false 
}) => {
  const [name, setName] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    if (item) {
      setName(item.name || '');
      setQuantity(item.quantity || 1);
      setSelectedTags(item.tags || []);
    } else {
      setName('');
      setQuantity(1);
      setSelectedTags([]);
    }
  }, [item, isOpen]);

  const handleTagToggle = (tag) => {
    setSelectedTags(prev => 
      prev.includes(tag)
        ? prev.filter(t => t !== tag)
        : [...prev, tag]
    );
  };

  const handleSave = () => {
    if (isCustom && !name.trim()) {
      return;
    }
    
    const itemData = {
      name: isCustom ? name.trim() : item.name,
      isCustom,
      quantity: parseInt(quantity, 10) || 1,
      tags: selectedTags
    };

    // Preserve id if it exists (for predefined items)
    if (item && item.id) {
      itemData.id = item.id;
    }

    onSave(itemData);
    onClose();
  };

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (value >= 1 && value <= 99) {
      setQuantity(value);
    } else if (e.target.value === '') {
      setQuantity('');
    }
  };

  return (
    <AccessibleModal
      isOpen={isOpen}
      onClose={onClose}
      title={item ? 'עריכת פריט' : 'הוספת פריט'}
    >
      <div className="space-y-6">
        {/* Item Name - only for custom items */}
        {isCustom && (
          <div>
            <label htmlFor="item-name" className="form-label">
              שם הפריט *
            </label>
            <input
              id="item-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="input-field"
              placeholder="הזן שם פריט"
              maxLength={100}
              required
            />
          </div>
        )}

        {/* Display name for predefined items */}
        {!isCustom && item && (
          <div>
            <div className="form-label">שם הפריט</div>
            <div className="input-field bg-gray-50">
              {item.name}
            </div>
          </div>
        )}

        {/* Quantity */}
        <div>
          <label htmlFor="item-quantity" className="form-label">
            כמות *
          </label>
          <input
            id="item-quantity"
            type="number"
            value={quantity}
            onChange={handleQuantityChange}
            className="input-field"
            min="1"
            max="99"
            required
          />
          <p className="text-sm text-gray-500 mt-1">כמות בין 1 ל-99</p>
        </div>

        {/* Tags */}
        <div>
          <div className="form-label mb-3">תיוגים</div>
          <div className="space-y-2">
            {ITEM_TAGS.map(tag => (
              <label
                key={tag}
                className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors"
              >
                <input
                  type="checkbox"
                  checked={selectedTags.includes(tag)}
                  onChange={() => handleTagToggle(tag)}
                  className="ml-3 h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 rounded"
                />
                <span className="text-brown-700">{tag}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Buttons */}
        <div className="flex space-x-4 space-x-reverse pt-4">
          <button
            onClick={onClose}
            className="btn-secondary flex-1"
          >
            ביטול
          </button>
          <button
            onClick={handleSave}
            disabled={isCustom && !name.trim()}
            className="btn-primary flex-1 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            שמור
          </button>
        </div>
      </div>
    </AccessibleModal>
  );
};

export default ItemEditModal;

